import { LogoutOutlined, SettingsOutlined } from '@mui/icons-material';
import { Avatar, Box, Button, Divider, IconButton, Typography } from '@mui/material';
import React, { useState } from 'react';
import { User, logout } from '../services/api.ts';
import SettingsDialog from './SettingsDialog.tsx';

interface UserProfileProps {
  user: User;
}

const UserProfile: React.FC<UserProfileProps> = ({ user }) => {
  const [settingsOpen, setSettingsOpen] = useState(false);
  
  const handleLogout = async () => {
    try {
      await logout();
      // Force page reload to clear any cached state
      window.location.reload();
    } catch (error) {
      console.error('Error logging out:', error);
      window.location.href = '/';
    }
  };

  const userName = user.first_name ? 
    `${user.first_name}${user.last_name ? ' ' + user.last_name : ''}` : 
    user.email ? user.email.split('@')[0] : 'User';

  return (
    <>
      <Box 
        sx={{ 
          display: 'flex', 
          alignItems: 'center', 
          gap: 1.5,
          bgcolor: 'rgba(255, 255, 255, 0.8)',
          borderRadius: 2,
        }}
      >
        <Avatar 
          src={user.image_url || undefined} 
          alt={user.first_name || 'User'}
          sx={{ width: 32, height: 32 }}
        />
        <Typography 
          variant="body2" 
          sx={{ 
            fontWeight: 500,
            color: 'text.primary',
            display: { xs: 'none', sm: 'block' }
          }}
        >
          {userName}
        </Typography>
        <Divider orientation="vertical" variant="middle" flexItem />
        <IconButton
          size="small"
          onClick={() => setSettingsOpen(true)}
          sx={{ 
            color: 'text.secondary',
            '&:hover': { color: 'primary.main' }
          }}
        >
          <SettingsOutlined fontSize="small" />
        </IconButton>
        <Button
          size="small"
          variant="text"
          color="inherit"
          onClick={handleLogout}
          startIcon={<LogoutOutlined fontSize="small" />}
          sx={{ 
            color: 'text.secondary',
            '&:hover': { color: 'error.main' },
            minWidth: { xs: '32px', sm: 'auto' },
            px: { xs: 0, sm: 1 }
          }}
        >
          <Box component="span" sx={{ display: { xs: 'none', sm: 'inline' } }}>
            Sign out
          </Box>
        </Button>
      </Box>
      
      <SettingsDialog open={settingsOpen} onClose={() => setSettingsOpen(false)} />
    </>
  );
};

export default UserProfile; 